/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UserListTableSessionQueryVariables = {};
export type UserListTableSessionQueryResponse = {
    readonly currentSession: {
        readonly user?: {
            readonly id: string;
        } | undefined;
    } | null;
};
export type UserListTableSessionQuery = {
    readonly response: UserListTableSessionQueryResponse;
    readonly variables: UserListTableSessionQueryVariables;
};



/*
query UserListTableSessionQuery {
  currentSession {
    __typename
    ... on Session {
      user {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserListTableSessionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "currentSession",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserListTableSessionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "currentSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f673eabe3a6f10ca376a61339d7a83ba",
    "id": null,
    "metadata": {},
    "name": "UserListTableSessionQuery",
    "operationKind": "query",
    "text": "query UserListTableSessionQuery {\n  currentSession {\n    __typename\n    ... on Session {\n      user {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e3eb1a647579b59038293a8d0ec19da6';
export default node;
